import { IBasicCourse } from '@sdk/contracts';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { ConfirmationContent } from '../../Sections/ConfirmationContent';

type Props = {
  handleConfirm: () => void;
  handleCancel: () => void;
  isOpen: boolean;
  syncedCourses: IBasicCourse[];
};

export const ActivityConfirmationContent: React.FC<Props> = ({
  handleConfirm,
  handleCancel,
  isOpen,
  syncedCourses
}) => {
  const { t } = useTranslation(['ManagerBaseContentDetailTranslations', 'DefaultTranslations']);

  return (
    <Modal
      centered
      open={isOpen}
      title={t('ManagerBaseContentDetailTranslations:CONFIRM_SAVE_TITLE')}
      okText={t('DefaultTranslations:CONFIRM')}
      onOk={handleConfirm}
      onCancel={handleCancel}>
      <ConfirmationContent syncedCourses={syncedCourses} />
    </Modal>
  );
};
